export const colorsTheme = {
  white: '#FFFFFF',
  black: '#000000',
  danger: '#F2383A',

  'gradient-deg': '294deg',
  'gradient-primary': '#FFCE00',
  'gradient-secondary': '#FFCE00',

  'primary-color': '#FFCE00',
  'secondary-color': '#FFCE00',
  'auxiliary-color': '#FFCE00',

  'secondary-button-background': 'transparent',
  'secondary-button-background-hover': '#FFCE00',
  'secondary-button-color': '#FFCE00',
  'secondary-button-color-hover': '#FFFFFF',
  'secondary-button-border': '#FFCE00',
  'secondary-button-border-hover': '#FFCE00',

  'bg-color': '#FFFFFF',
  'bg-secondary-color': '#1A1A1A',
  'bg-auxiliary-color': '#EDEDED',

  'bg-circle-color': '#FFFFFF',
  'bg-circle-hover': '#C7DEFF',
  'bg-circle-text-color': '#000',
  'bg-circle-text-color-hover': '#FFFFFF',

  'filter-button-background': '#FFCE00',
  'filter-button-color': '#FFFFFF',
  'filter-button-border': '#FFCE00',
  'entry-message-color': '#FFCE00',

  'bg-modal-color': '#FFFFFF',

  'dark-color': '#3F3F3F',

  'text-primary': '#1E1E1E',
  'text-secondary': '#FFCE00;',
  'text-gray': '#4F4F4F',

  'input-color': '#1E1E1E',
  'bg-input-color': '#FFFFFF',
  'info-color': '#C7DEFF',
  'disabled-color': '#e2e2e2',
  'card-color': '#EEEEEE',
  'modal-border-color': '#ADB5BD',
  'border-color': '#FFCE00',

  'echeck-label-color': '#000',
  'echeck-border-color': '#D2D2D2',
  'echeck-text-color': '#000',
  'echeck-bar-color1': '#FFCE00',
  'echeck-bar-color2': '#FFCE00'
};
